import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

/*------------------ CHANNEL STORE MODULES -----------------------*/
import ChannelStore from './channel/channelStore'

/* ------------------------------ SUB-BRAND STORES ----------------------------------- */
import AppStore from './subbrand/appStore'
import ComponentStore from './subbrand/componentStore'
import CreateSubbrandStore from './subbrand/createSubbrandStore'
import SubbrandListStore from './subbrand/subbrandList'
import SubbrandOverviewStore from './subbrand/subbrandOverviewStore'

/*------------------ CUSTOMIZATION STORE MODULES -----------------------*/
import CustAppStore from './customization/custAppStore'
import ParamStore from './customization/paramStore'
import LocaleStore from './customization/localeStore'
import CssStore from './customization/cssStore'

export default new Vuex.Store({
  modules: {
    channelStore: ChannelStore,
    appStore: AppStore,
    componentStore: ComponentStore,
    createSubbrandStore: CreateSubbrandStore,
    subbrandListStore: SubbrandListStore,
    subbrandOverviewStore: SubbrandOverviewStore,
    custAppStore: CustAppStore,
    paramStore: ParamStore,
    localeStore: LocaleStore,
    cssStore: CssStore
  }
})